import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { EndpointService } from "@app/core";
import { ToastrService } from "ngx-toastr";

export interface TipoDocumental {
  id: number;
  nombre: string;
  codigo: string;
  expediente: boolean;
  subserie: number;
}

export interface Sticker {
  id: number;
  nombre: string;
  tipo_documental: TipoDocumental;
}

export interface DownloadSticker {
  path: string;
  name: string;
}

export interface previewSticker {
  path: string;
  name: string;
}

@Injectable()
export class StampDataService{
  constructor(private http: HttpClient, private api: EndpointService, private toastr: ToastrService) {}

  /**
   *Consulta los rótulos o stickers por tipo documental
   *
   * @param {number} id
   * @return {*}  {Observable<Sticker[]>}
   * @memberof FilingStructureDataService
   */
  getStickers(id: number): Observable<Sticker[]> {
    return new Observable((obs) => {
      this.http.get<Sticker[]>(this.api.get("sticker_document", [id])).subscribe(
        (sticker) => {
          obs.next(sticker);
        },
        (err) => {
          obs.error(err);
        }
      );
    });
  }

  /**
   *Consulta los rótulos o stickers por tipo documental
   *
   * @param {number} id
   * @return {*}  {Observable<Sticker[]>}
   * @memberof FilingStructureDataService
   */
   getStickersSpecial(serie: number,subserie: number, type_document:number): Observable<Sticker[]> {
    let sticker = new FormData;
    if(serie){
      sticker.append("serie", serie.toString());
    };
    if(subserie){
      sticker.append("sub_serie", subserie.toString());
    };
    if(type_document){
      sticker.append("tipo_documental", type_document.toString());
    }; 
    return new Observable((obs) => {
      this.http.post<Sticker[]>(this.api.get("stickerDocumentSpecial"),sticker).subscribe(
        (sticker) => {
          obs.next(sticker);
        },
        (err) => {
          obs.error(err);
        }
      );
    });
  }

  /**
   *Agrega un sticker o rótulo
   *
   * @param {FormData} sticker
   * @return {*}  {Promise<boolean>}
   * @memberof StampDataService
   */
  addSticker(sticker: FormData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('sticker_document'),
      sticker).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Rótulo/Sticker agregado correctamente');
          resolve(true);
        },
        err => {
          if(err.status == 400){
            this.toastr.warning(err.error,'Error');
          }
          reject(err);
        }
      );
    });
  }

  /**
   *Obtiene la ruta de descarga del rótulo
   *
   * @param {number} id
   * @return {*}  {Observable<DownloadSticker>}
   * @memberof StampDataService
   */
  downloadSticker(id: number): Observable<DownloadSticker>{
    return new Observable((obs) => {
      this.http.get<DownloadSticker>(this.api.get("download_sticker", [id])).subscribe(
        (sticker) => {
          obs.next(sticker);
        },
        (err) => {
          obs.error(err);
        }
      );
    });
  }

 
  /**
   *Actualiza un rótulo o sticker
   *
   * @param {number} id
   * @param {FormData} sticker
   * @return {*}  {Promise<boolean>}
   * @memberof StampDataService
   */
  updateSticker(id: number, sticker: FormData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('sticker_document', [id]), sticker).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Rótulo/Sticker modificado correctamente');
          resolve(true);
        },
        err => {
          if(err.status == 400){
            this.toastr.warning(err.error,'Error');
          }
          reject(err);
        }
      );
    });
  }

  /**
   *Elimina sticker del sistema
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof StampDataService
   */
  deleteSticker(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get("sticker_document", [id])).subscribe(
        (_resp) => {
          this.toastr.success("Operación exitosa", "Rótulo eliminado correctamente");
          resolve(true);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  /**
   *Permite previzualizar un sticker
   *
   * @param {any} data
   * @return {*}  {Promise<boolean>}
   * @memberof StampDataService
   */
   previewSticker(data: any): Observable<previewSticker>{
    return new Observable((obs) => {
      this.http.post<previewSticker>(this.api.get('download_sticker'),
      data).subscribe(
        (sticker) => {
          obs.next(sticker);
        },
        (err) => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/stamp/shared/stamp.data.service.ts